import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import { isStandaloneMode } from '../../lib/pwa';

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(
    () => typeof navigator !== 'undefined' && !navigator.onLine
  );

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  const installedHint = isStandaloneMode()
    ? ' Le pagine già visitate restano disponibili; i dati su Firebase richiedono connessione.'
    : ' Alcune funzioni potrebbero non essere disponibili finché non torni online.';

  return (
    <div
      role="status"
      aria-live="polite"
      className="border-b border-brand-orange/30 bg-brand-orange/15 px-4 py-2.5 text-center text-sm text-[var(--ba-body-text)]"
    >
      <p className="inline-flex flex-wrap items-center justify-center gap-2">
        <WifiOff className="h-4 w-4 shrink-0 text-brand-orange" aria-hidden />
        <span>
          <strong>Sei offline.</strong>
          {installedHint}
        </span>
      </p>
    </div>
  );
}
